<template>
  <el-dialog
    title="修改审批人"
    :visible.sync="visible"
    width="500px"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      element-loading-text="加载中…"
      ref="ruleForm"
      label-width="100px"
      label-position="right"
      :model="ruleForm"
      :rules="rules"
    >
      <el-form-item :label="`${curRow.step_name}:`" prop="pass">
        {{ curRow.admin_name }}{{ curRow.account }}
      </el-form-item>
      <el-form-item label="修改为:" prop="personId">
        <el-select
          v-model="ruleForm.personId"
          filterable
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in accountArr"
            :key="item.id"
            :label="`${item.name}  (${item.account})`"
            :value="item.id"
          >
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">({{ item.account }})</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggle(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        :disabled="loading"
        @click="confirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      accountArr: [],
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      curRow: {},
      ruleForm: {
        personId: "",
      },
      rules: {
        personId: [{ required: true, message: "必填", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getAccountList();
  },
  methods: {
    getAccountList() {
      this.$http
        .get("admin/admin/list", { params: { page: 1, count: 10000 } })
        .then((res) => {
          if (res.code === 1) {
            this.accountArr = res.data.list;
          }
        });
    },
    getDetail(row) {
      this.curRow = row;
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .post("/admin/approval/updateApproval", {
              id: this.curRow.id,
              admin_id: this.ruleForm.personId,
            })
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功！");
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    reset(done) {
      this.$refs.ruleForm.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>